import { Link } from "react-router";

export function PageNotice({ line, back }: { line: string; back: string }) {
  return (
    <div className="flex min-h-0 flex-1 items-center justify-center overflow-auto bg-[var(--color-bg)] p-[24px]">
      <div className="flex w-full max-w-[560px] flex-col gap-[12px] rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-paper)] px-[20px] py-[18px]">
        <p className="font-(family-name:--font-display) text-md text-[var(--color-text-strong)]">
          {line}
        </p>
        <p className="mt-[4px] font-(family-name:--font-display) text-sm">
          <Link to="/" className="text-[var(--color-brand)] underline-offset-2 hover:underline">
            {back}
          </Link>
        </p>
      </div>
    </div>
  );
}
